export default __webpack_public_path__ + "static/media/offering1.df830070.png";